export default {"src":"/_next/static/image/public/images/ic_like_filled.c4cba54037a6035c35c2ae6413dee7ea.svg","height":24,"width":25};